import { Screen } from '@rahtab/stack-navigator';
import { Card, getSpacing, Text, TextView } from '@rahtab/ui';
import { RouteProp } from '@react-navigation/core';
import React, { useEffect, useState } from 'react';
import { useRequest } from '@rahtab/auth/lib/token-based-auth';
import { RootStackType } from '../../Router';

const ViewMessage: React.FC<RequestParams> = ({ route }) => {
  const [loading, setLoading] = useState(false);

  const [message, setMessage] = useState<ServerMessageType>({
    DocumentCode: '',
    MessageDate: '',
    MessageText: '',
    MessageTime: '',
    MessageTitle: '',
    UploadFile: '',
    UserImage: '',
    UserName: '',
  });
  const request = useRequest();
  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const fullMessage = await request<{ Result: ServerMessageType }>('MessageFullInfo', {
          params: `DC=${route.params.id}&MessageType=${route.params.type}`,
        });
        setLoading(false);
        setMessage({ ...fullMessage.Result });
      } catch {
        setLoading(false);
      }
    })();
  }, []);
  return (
    <Screen
      loading={loading}
      renderMain={() => {
        return (
          <Card style={{ margin: getSpacing(), padding: getSpacing() }}>
            <TextView title="عنوان پیام" value={message.MessageTitle} />
            <TextView title="فرستنده پیام" value={message.UserName} />
            <Card style={{ padding: getSpacing() }}>
              <Text style={{ textAlign: 'justify' }}>{message.MessageText}</Text>
            </Card>
          </Card>
        );
      }}
    />
  );
};
export default ViewMessage;

interface RequestParams {
  id: string;
  type: 'Recieve' | 'Send';
  route: RouteProp<RootStackType, 'ViewMessage'>;
}
interface ServerMessageType {
  DocumentCode: string;
  MessageDate: string;
  MessageText: string;
  MessageTime: string;
  MessageTitle: string;
  UploadFile: string;
  UserImage: string;
  UserName: string;
}
